import { FunctionComponent, useEffect } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { LoadingSpinner } from '../../component/Spinner';
import { useUsersStore } from '../../hooks';

const UserIndexPage: FunctionComponent = () => {
  const userStore = useUsersStore();

  useEffect(() => {
    userStore.fetchAll();
    return () => userStore.clear();
  }, []);
  
  return (
    <Container>
      <Row>
        <Col>
          <h2>Users</h2>

          <Table>
            <thead>
              <tr>
                <th scope="col">
                  Subject (id)
                </th>
                <th scope="col">
                  Forename
                </th>
                <th scope="col">
                  Surname
                </th>
                <th scope="col">
                  Email
                </th>
                <th scope="col">
                  &nbsp;
                </th>
              </tr>
            </thead>
            <tbody>
              {userStore.loading && (
                <tr>
                  <td colSpan={5}>
                    <LoadingSpinner />
                  </td>
                </tr>
              )}

              {userStore.users.map(user => (
                <tr key={user.sub}>
                  <td>{user.sub}</td>
                  <td>{user.forename}</td>
                  <td>{user.surname}</td>
                  <td>{user.email}</td>
                  <td>
                    <LinkContainer to={`/users/${user.username}`}>
                      <Button variant="outline-primary" size="sm">
                        View
                      </Button>
                    </LinkContainer>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="text-center">
            <Button variant="outline-primary" size="sm" onClick={userStore.fetchMore} disabled={userStore.loading || !userStore.hasMore()}>
              Load more
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default UserIndexPage;
